import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Industryusa = () => {
  return (
    <div className="Industry_usa tekrevol_dark_bg  p-100 ">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={5} lg={5} xl={5} xxl={5}>
            <h2>
              WordPress Website Development Services For Different{" "}
              <span>Industries</span>
            </h2>
            <p>
              Our WordPress website design services meet the distinct needs of
              various industries. We prioritize user-friendly, high-performance
              websites that align with industry standards for a strong online
              presence and optimal functionality across diverse sectors.
            </p>
            <p>Here are the industries that we serve:</p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Build Your WordPress Website
            </Link>
          </Col>
          <Col
            xs={12}
            md={4}
            lg={4}
            xl={4}
            xxl={4}
            className="offset-lg-3 offset-md-3 my-auto"
          >
            <div className="industry_scroll">
              <h3>Retail</h3>
              <h3>E-commerce</h3>
              <h3>Insurance</h3>
              <h3>FinTech</h3>
              <h3>Entertainment </h3>
              <h3>Health & Fitness</h3>
              <h3>Lifestyle</h3>
              <h3>Education</h3>
              <h3>Real Estate</h3>
              <h3>Logistics</h3>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Industryusa;
